function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M1.41999 18.5787C1.13948 18.5782 0.872062 18.4599 0.682993 18.2527C0.490439 18.0471 0.394758 17.7692 0.419993 17.4887L0.664993 14.7947L11.983 3.48066L15.52 7.01666L4.20499 18.3297L1.51099 18.5747C1.47999 18.5777 1.44899 18.5787 1.41999 18.5787ZM16.226 6.30966L12.69 2.77366L14.811 0.652662C14.9986 0.464885 15.2531 0.359375 15.5185 0.359375C15.7839 0.359375 16.0384 0.464885 16.226 0.652662L18.347 2.77366C18.5348 2.96123 18.6403 3.21575 18.6403 3.48116C18.6403 3.74657 18.5348 4.00109 18.347 4.18866L16.227 6.30866L16.226 6.30966Z",
  fill: "#16B187"
});

function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.c4ef974f.svg";
export { ForwardRef as ReactComponent };